
export default (history, store) => (location, action) => {
  window.scrollTo(0, 0)
}



// WEBPACK FOOTER //
// ./src/history/scrollMiddleware.js